import type { Period } from "@yarnalytics/shared";

const periods: { label: string; value: Period }[] = [
  { label: "7D", value: "7d" },
  { label: "30D", value: "30d" },
  { label: "90D", value: "90d" },
];

interface Props {
  value: Period;
  onChange: (period: Period) => void;
  disabledValues?: Period[];
}

export function PeriodSelector({
  value,
  onChange,
  disabledValues = [],
}: Props) {
  return (
    <div className="flex gap-1 rounded-lg bg-inset p-1">
      {periods.map((p) => {
        const isDisabled = disabledValues.includes(p.value);
        let stateClass = "";
        if (isDisabled) {
          stateClass =
            value === p.value
              ? "bg-neutral-200 text-neutral-400 cursor-not-allowed"
              : "text-neutral-300 cursor-not-allowed";
        } else if (value === p.value) {
          stateClass = "bg-black text-white";
        } else {
          stateClass = "text-neutral-500 hover:text-black";
        }

        return (
          <button
            key={p.value}
            onClick={() => {
              if (!isDisabled) {
                onChange(p.value);
              }
            }}
            disabled={isDisabled}
            className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${stateClass}`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}
